<template>
    <router-view v-slot="{ Component, route }">
        <keep-alive include="TimelinePage">
            <component :is="Component" :key="route.fullPath" />
        </keep-alive>
    </router-view>
</template>
